export type ConnectorId = 'freebe' | 'bnp' | 'trello' | 'google-drive';
export interface ConnectorLogoRevision {
  readonly connectorId: ConnectorId;
  readonly revision: string;
}

export const connectorLogoApi = {
  async list(): Promise<readonly ConnectorLogoRevision[]> {
    const response = await fetch('/api/connectors/logos', { credentials: 'include' });
    if (!response.ok) throw new Error('Logos des connecteurs indisponibles.');
    return response.json() as Promise<readonly ConnectorLogoRevision[]>;
  },
  url(id: ConnectorId, revisions: readonly ConnectorLogoRevision[]): string | null {
    const revision = revisions.find((item) => item.connectorId === id)?.revision;
    return revision ? `/api/connectors/${id}/logo?v=${encodeURIComponent(revision)}` : null;
  },
  async save(id: ConnectorId, file: File, csrfToken: string): Promise<{ revision: string }> {
    const response = await fetch(`/api/platform/connector-logos/${id}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': file.type, 'X-CSRF-Token': csrfToken },
      body: file,
    });
    if (!response.ok) throw new Error('Logo refusé.');
    return response.json() as Promise<{ revision: string }>;
  },
  async remove(id: ConnectorId, csrfToken: string): Promise<void> {
    const response = await fetch(`/api/platform/connector-logos/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'X-CSRF-Token': csrfToken },
    });
    if (!response.ok) throw new Error('Suppression refusée.');
  },
};
